// extracted by mini-css-extract-plugin
export var card = "Card-module--card--08a01";
export var content = "Card-module--content--11cb5";
export var date = "Card-module--date--6bfda";
export var floating = "Card-module--floating--9b755";
export var image = "Card-module--image--50690";
export var inline = "Card-module--inline--de56b";
export var speaker = "Card-module--speaker--f4dd3";
export var text = "Card-module--text--fcc55";
export var title = "Card-module--title--ddaeb";